// (function() {
//     'use strict';

//     function HiddenItems($stateProvider) {
//         $stateProvider.state('hiddenItems example page', {
//             url: '/hiddenItems/example',
//             templateUrl: 'hidden-items/views/index.html'
//         }).state('hiddenItems circles example', {
//             url: '/hiddenItems/example/:circle',
//             templateUrl: 'hidden-items/views/example.html'
//         });
//     }

//     angular
//         .module('mean.hidden-items')
//         .config(HiddenItems);

//     HiddenItems.$inject = ['$stateProvider'];

// })();



// WEBPACK FOOTER //
// ./packages/custom/hidden-items/public/routes/hiddenItems.js